module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/nav-left-old/nav-left-old.component.css
// module id = ./src/app/components/nav-left-old/nav-left-old.component.css
// module chunks = main